// Cliente del PUENTE DE HARDWARE del local (print-agent Fase 2): balanza,
// cajón monedero y display cliente vía WebSocket ws://127.0.0.1:9102 (la PC de
// la caja corre el agente; ver Ayuda POS → pestaña Impresión y hardware).
// Conexión perezosa con reintento suave: si no hay agente, todo queda en
// conectado=false y el POS funciona igual (el puente es 100% opcional).
import { useEffect, useState } from 'react';

export interface CapacidadesPuente { balanza: boolean; cajon: boolean; display: boolean }
export interface EstadoPuente {
  conectado: boolean;
  capacidades: CapacidadesPuente;
  peso: number | null;   // kg reportados por la balanza (último valor)
  estable: boolean;
}

const URL_PUENTE = 'ws://127.0.0.1:9102';
const REINTENTO_MS = 15000;

let ws: WebSocket | null = null;
let iniciado = false;
let estado: EstadoPuente = { conectado: false, capacidades: { balanza: false, cajon: false, display: false }, peso: null, estable: false };
const subs = new Set<(e: EstadoPuente) => void>();
const emitir = () => { for (const s of subs) s({ ...estado }); };

function conectar() {
  try {
    ws = new WebSocket(URL_PUENTE);
  } catch {
    ws = null;
    setTimeout(conectar, REINTENTO_MS);
    return;
  }
  ws.onopen = () => { estado = { ...estado, conectado: true }; emitir(); };
  ws.onmessage = (ev) => {
    try {
      const m = JSON.parse(String(ev.data));
      if (m.tipo === 'pong') estado = { ...estado, conectado: true, capacidades: m.capacidades ?? estado.capacidades };
      else if (m.tipo === 'peso') estado = { ...estado, peso: Number(m.kg), estable: Boolean(m.estable) };
      else return;
      emitir();
    } catch { /* mensaje ajeno */ }
  };
  ws.onclose = () => {
    ws = null;
    if (estado.conectado) { estado = { ...estado, conectado: false, peso: null }; emitir(); }
    setTimeout(conectar, REINTENTO_MS);
  };
  ws.onerror = () => { try { ws?.close(); } catch { /* noop */ } };
}

function asegurar() {
  if (!iniciado) { iniciado = true; conectar(); }
}

/** Estado en vivo del puente (conexión + capacidades + peso de la balanza). */
export function usePuenteHardware(): EstadoPuente {
  const [e, setE] = useState<EstadoPuente>(estado);
  useEffect(() => {
    asegurar();
    const s = (n: EstadoPuente) => setE(n);
    subs.add(s);
    setE({ ...estado });
    return () => { subs.delete(s); };
  }, []);
  return e;
}

const enviar = (obj: Record<string, unknown>) => {
  if (ws && ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify(obj));
};

/** Abre el cajón monedero configurado en el agente (pulso ESC/POS). */
export const abrirCajonLocal = () => enviar({ accion: 'cajon' });

/** Muestra dos líneas (máx. 20 caracteres c/u) en el display del cliente. */
export const displayCliente = (l1: string, l2 = '') => enviar({ accion: 'display', l1, l2 });
